import { Badge } from "@/components/ui/badge"
import { useListEmailThreads } from "@/stores/emails.store"

/**
 * Unread conversation count beside the sidebar's Inbox item. Muted and
 * snoozed threads don't count. Hidden from the link's accessible name so the
 * item stays "Inbox" to assistive tech and tests.
 */
export function InboxNavBadge() {
  const { unreadCount } = useListEmailThreads({ limit: 1 })
  if (!unreadCount) return null
  return (
    <Badge aria-hidden="true" className="ml-auto h-5 min-w-5 justify-center px-1.5 text-[10px] group-data-[collapsible=icon]:hidden">
      {unreadCount > 99 ? "99+" : unreadCount}
    </Badge>
  )
}
